import { jsx } from "react/jsx-runtime";
import { createElement, forwardRef } from "react";
import { useTheme } from "@mui/material/styles";
import { borders, display, flexbox, grid, positions, shadows, sizing, typography } from "@mui/system";
import styled_components from "styled-components";
import get from "lodash/get";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function Box_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else Box_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const getRadiusString = (radius, radiusTokens)=>{
    if (!radius || !radiusTokens) return;
    return Array.isArray(radius) ? radius.map((el)=>`${radiusTokens[el]}px`).join(' ') : `${radiusTokens[radius]}`.concat('round' === radius ? '' : 'px');
};
const Box = styled_components(/*#__PURE__*/ forwardRef((_0, _1)=>{
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { component, testId = 'box' } = _ref1, props = _object_without_properties(_ref1, [
        "component",
        "testId"
    ]), [ref] = _rest;
    const { children, className, style, id, tabIndex, cursor, onClick, onFocus, onBlur, onChange, onContextMenu, onDrag, onDragEnd, onDragEnter, onDragExit, onDragLeave, onDragOver, onDragStart, onDrop, onKeyDown, onKeyPress, onKeyUp, onMouseDown, onMouseEnter, onMouseLeave, onMouseMove, onMouseOut, onMouseOver, onMouseUp, onTouchStart, onTouchEnd, title, 'data-mui-internal-clone-element': dataMuiInternalCloneElement } = props;
    const htmlProps = {
        ref,
        children,
        className: `aqa_box${className ? ` ${className}` : ''}`,
        style,
        id,
        tabIndex,
        cursor,
        onClick,
        onFocus,
        onBlur,
        onChange,
        onContextMenu,
        onDrag,
        onDragEnd,
        onDragEnter,
        onDragExit,
        onDragLeave,
        onDragOver,
        onDragStart,
        onDrop,
        onKeyDown,
        onKeyPress,
        onKeyUp,
        onMouseDown,
        onMouseEnter,
        onMouseLeave,
        onMouseMove,
        onMouseOut,
        onMouseOver,
        onMouseUp,
        onTouchStart,
        onTouchEnd,
        title,
        'data-mui-internal-clone-element': dataMuiInternalCloneElement,
        'data-testid': testId
    };
    if (!component) return /*#__PURE__*/ createElement('div', htmlProps);
    {
        if ('string' == typeof component) return /*#__PURE__*/ createElement(component, htmlProps);
        const Component = component;
        return /*#__PURE__*/ jsx(Component, _object_spread_props(_object_spread({
            ref: ref
        }, props), {
            className: `aqa_box${className ? ` ${className}` : ''}`
        }));
    }
}))((_0)=>{
    let { gap, transform, m, mt, mr, mb, ml, mx, my, p, pt, pr, pb, pl, px, py, margin, marginTop, marginRight, marginBottom, marginLeft, marginX, marginY, padding, paddingTop, paddingRight, paddingBottom, paddingLeft, paddingX, paddingY, bgcolor, color, borderColor, radius, cursor, pointerEvents, borderBottomRightRadius, borderTopRightRadius, borderBottomLeftRadius, borderTopLeftRadius, clipPath, scrollbarWidth, opacity, transition, wordBreak, overflowWrap, maskImage, WebkitMaskImage } = _0, props = _object_without_properties(_0, [
        "gap",
        "transform",
        "m",
        "mt",
        "mr",
        "mb",
        "ml",
        "mx",
        "my",
        "p",
        "pt",
        "pr",
        "pb",
        "pl",
        "px",
        "py",
        "margin",
        "marginTop",
        "marginRight",
        "marginBottom",
        "marginLeft",
        "marginX",
        "marginY",
        "padding",
        "paddingTop",
        "paddingRight",
        "paddingBottom",
        "paddingLeft",
        "paddingX",
        "paddingY",
        "bgcolor",
        "color",
        "borderColor",
        "radius",
        "cursor",
        "pointerEvents",
        "borderBottomRightRadius",
        "borderTopRightRadius",
        "borderBottomLeftRadius",
        "borderTopLeftRadius",
        "clipPath",
        "scrollbarWidth",
        "opacity",
        "transition",
        "wordBreak",
        "overflowWrap",
        "maskImage",
        "WebkitMaskImage"
    ]);
    const theme = useTheme();
    const styles = _object_spread_props(_object_spread(_object_spread_props(_object_spread(_object_spread_props(_object_spread({}, borders(_object_spread_props(_object_spread({}, props), {
        borderRadius: getRadiusString(radius, theme.tokens.radius),
        borderColor: void 0
    }))), {
        borderBottomRightRadius: getRadiusString(borderBottomRightRadius, theme.tokens.radius),
        borderTopRightRadius: getRadiusString(borderTopRightRadius, theme.tokens.radius),
        borderBottomLeftRadius: getRadiusString(borderBottomLeftRadius, theme.tokens.radius),
        borderTopLeftRadius: getRadiusString(borderTopLeftRadius, theme.tokens.radius)
    }), display(props), flexbox(props), grid(props), positions(props), shadows(props), sizing(props), typography(props)), {
        cursor,
        clipPath,
        pointerEvents: pointerEvents || 'auto',
        opacity: opacity || 1.0,
        transition,
        scrollbarWidth,
        wordBreak,
        overflowWrap,
        maskImage,
        WebkitMaskImage,
        gap: gap && theme.tokens.spacing[Math.abs(parseInt(gap, 10)).toString()],
        transform
    }), bgcolor && {
        backgroundColor: get(theme.tokens.colors, bgcolor)
    }, color && {
        color: get(theme.tokens.colors, color)
    }, borderColor && {
        borderColor: get(theme.tokens.colors, borderColor)
    }), {
        createMediaQuery (breakpoint, propertyName, value) {
            if (null == value) return;
            this[theme.breakpoints.up(breakpoint)] = _object_spread_props(_object_spread({}, this[theme.breakpoints.up(breakpoint)]), {
                [propertyName]: 'auto' === value || 'unset' === value ? value : (value.startsWith('-') ? -1 : 1) * theme.tokens.spacing[Math.abs(parseInt(value, 10)).toString()]
            });
        },
        createSpacingStyles (propertyName, value) {
            if (null == value) return;
            if ('string' == typeof value) this[propertyName] = 'auto' === value || 'unset' === value ? value : (value.startsWith('-') ? -1 : 1) * theme.tokens.spacing[Math.abs(parseInt(value, 10)).toString()];
            else {
                if (!Object.keys(value).length || Array.isArray(value)) return;
                const { xs, sm, md, lg, xl } = value;
                this.createMediaQuery('xs', propertyName, xs);
                this.createMediaQuery('sm', propertyName, sm);
                this.createMediaQuery('md', propertyName, md);
                this.createMediaQuery('lg', propertyName, lg);
                this.createMediaQuery('xl', propertyName, xl);
            }
        }
    });
    styles.createSpacingStyles('margin', margin || m);
    styles.createSpacingStyles('marginTop', marginTop || mt);
    styles.createSpacingStyles('marginRight', marginRight || mr);
    styles.createSpacingStyles('marginBottom', marginBottom || mb);
    styles.createSpacingStyles('marginLeft', marginLeft || ml);
    styles.createSpacingStyles('marginLeft', marginX || mx);
    styles.createSpacingStyles('marginRight', marginX || mx);
    styles.createSpacingStyles('marginTop', marginY || my);
    styles.createSpacingStyles('marginBottom', marginY || my);
    styles.createSpacingStyles('padding', padding || p);
    styles.createSpacingStyles('paddingTop', paddingTop || pt);
    styles.createSpacingStyles('paddingRight', paddingRight || pr);
    styles.createSpacingStyles('paddingBottom', paddingBottom || pb);
    styles.createSpacingStyles('paddingLeft', paddingLeft || pl);
    styles.createSpacingStyles('paddingLeft', paddingX || px);
    styles.createSpacingStyles('paddingRight', paddingX || px);
    styles.createSpacingStyles('paddingTop', paddingY || py);
    styles.createSpacingStyles('paddingBottom', paddingY || py);
    return styles;
});
Box.displayName = 'Box';
export { Box };
